module.exports = __webpack_public_path__ + "static/media/intro_pic1.5bb85e99.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/intro_pic1.png
 ** module id = 458
 ** module chunks = 0
 **/